export default __webpack_public_path__ + "static/media/download-ios-app.0387d3cb.svg";